import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import {
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import DataTables from 'material-ui-datatables';
import IconButton from 'material-ui/IconButton';
import FlatButton from 'material-ui/FlatButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import FontIcon from 'material-ui/FontIcon';
import Chip from 'material-ui/Chip';
import { fetchCustomers, setCustomer } from '../../actions/customers';
import Dashboard from '../Dashboard';
import Customer from '../Customer';
import { toJSSafe, sortStrings, contains, getOrderDirection } from '../../utils/helper';
import { removeCustomerRoutine } from '../../routines';
import { getTenantPath } from '../../utils/firebase';

import styles from './styles';
import FirebaseImage from '../Common/FirebaseImage/index';
import { hasPermission } from '../../utils/authenticated';
import { showDialog, hideDialog, isDialogOpen } from '../../actions/dialogs';
import Loading from '../Common/Loading';

const renderTag = (customerId, tag) => {
  return (<Chip
    labelStyle={styles.chipLabelStyle}
    style={styles.chip}
    key={`${customerId}-${tag}`}
  >{tag}</Chip>);
};

const getTableColumns = (editable, onEdit, onRemove) => {
  return _.flatten([
    {
      key: 'logo',
      label: '',
      render: (logo, all) => logo ? <FirebaseImage src={getTenantPath(`/customers/thumb_${logo}`)} height={40}/> : <FontIcon className="material-icons" style={styles.business}>business</FontIcon>,
      style: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        // textOverflow: 'ellipsis',
        width: 50,
      },
    }, {
      key: 'name',
      label: 'Customer',
      render: (name, customer) => name,
      sortable: true,
      style: {
        width: 150,
      },
    }, {
      key: 'customerManager',
      label: 'Customer Manager',
      render: (customerManager, customer) => customerManager ? customerManager.name : '',
      sortable: true,
      style: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: 110,
      },
    }, {
      key: 'primaryContact.name',
      label: 'Primary Contact',
      render: (name, customer) => customer.primaryContact ? customer.primaryContact.name : '',
      sortable: true,
      style: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: 110,
      },
    // }, {
    //   key: 'primaryContact.telephone',
    //   label: 'Telephone',
    //   render: (telephone, customer) => customer.primaryContact ? customer.primaryContact.telephone : '',
    //   style: {
    //     width: 90,
    //   },
    }, {
      key: 'primaryContact.email',
      label: 'Email',
      render: (email, customer) => customer.primaryContact ? customer.primaryContact.email : '',
      sortable: true,
      style: {
        width: 120,
      },
    }, {
      key: 'tags',
      label: 'Tags',
      render: (tags, customer) => (customer.tags || []).map((tag) => renderTag(customer.id, tag)),
      style: {
        // whiteSpace: 'wrap',
        overflow: 'hidden',
        // width: 160,
      },
    }, {
      key: 'action',
      label: '',
      render: (a, customer) => {
        return (<span><IconButton
          tooltip={ editable ? 'Edit' : 'View' }
          tooltipPosition="bottom-center"
          onClick={(evt) => onEdit(evt, customer)}
        >
          <FontIcon
            className="material-icons"
            style={styles.icon}
          >{ editable ? 'edit' : 'search' }</FontIcon>
        </IconButton>
          { editable ? <IconButton
            tooltip="Remove"
            tooltipPosition="bottom-center"
            onClick={(evt) => onRemove(evt, customer)}
          >
            <FontIcon
              className="material-icons"
              style={styles.icon}
            >delete</FontIcon>
          </IconButton> : null }
          </span>);
      },
      alignRight: true,
      style: {
        width: 150,
      },
    },
  ]);
};

const getSorter = (sorter = (a, b) => 0, order = 'asc') => {
  return (a, b) => {
    let result = sorter(a, b);

    if (result === 0) {
      result = sortStrings(a.name, b.name);
    }

    return result * getOrderDirection(order);
  };
};

const getFilter = (filter) => {
  return (customer) => {
    if (filter) {
      if (contains(customer.name, filter)) {
        return true;
      }
      if (customer.primaryContact && contains(customer.primaryContact.name, filter)) {
        return true;
      }

      return false;
    }

    return true;
  };
}

const getData = (allData, sortBy, filter, page, limit) => {
  const data = allData.filter(getFilter(filter ? filter.trim().toLowerCase() : '')).sort(sortBy);
  const result = {
    page: Math.min(page, Math.floor(data.length / limit) + 1),
    data,
    filter,
  };

  return result;
}

class Customers extends Component {
  static propTypes = {
    fetchCustomers: PropTypes.func.isRequired,
    setCustomer: PropTypes.func.isRequired,
    removeCustomer: PropTypes.func.isRequired,
    customers: PropTypes.array.isRequired,
    loading: PropTypes.bool,

    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    dialogs: PropTypes.object.isRequired,
  };

  state = {
    selectedRows: [],
    page: 1,
    limit: 10,
    sortBy: getSorter(),
    order: 'asc',
    data: [],
  };

  componentWillMount() {
    this.props.fetchCustomers();

    const { sortBy, page, limit, filter } = this.state;
    this.setState(_.assign({
      editable: hasPermission(['JobCreator', 'Administrator']),
    }, getData(this.props.customers, sortBy, filter, page, limit)));
  }

  componentWillReceiveProps(nextProps) {
    const { sortBy, page, limit, filter } = this.state;
    this.setState(getData(nextProps.customers, sortBy, filter, page, limit));
  }

  handleEdit = (evt, customer) => {
    evt.stopPropagation();
    this.props.setCustomer(customer);
    this.props.showDialog('customer');
  };

  handleRemove = (evt, customer) => {
    evt.stopPropagation();
    // if (confirm('Are you sure you wish to remove this customer?')) {
    //   this.props.removeCustomer(customer);
    // }
    this.handleRemoveCustomers([customer]);
  };

  handleMultiRemove = () => {
    if (this.state.selectedRows.length < 1) {
      return null;
    }

    const customers = this.state.paginatedCustomers.filter((customer, index) => {
      return ((this.state.selectedRows.map((val) => val)).includes(index));
    });

    this.handleRemoveCustomers(customers);
  };

  handleRemoveCustomers = (customers) => {
    const context = {
      type: 'warning',
      title: 'Remove Customers?',
      message: `Are you sure you wish to remove the ${customers.length > 1 ? customers.length : ''} 
      selected ${customers.length > 1 ? 'customers' : 'customer'}?`,
      buttons: [
        <FlatButton
          label="Cancel"
          onClick={() => this.props.hideDialog('confirm')}
        />,
        <FlatButton
          label="Remove"
          onClick={() => {
            this.props.hideDialog('confirm');
            customers.map(this.props.removeCustomer);
          }}
        />,
      ],
    };

    this.props.showDialog('confirm', context);
  };

  handleRowSelection = (evt) => {
    let selectedRows = [];
    switch (evt) {
      case 'all':
        selectedRows = _.range(0, this.state.limit);
        break;
      case 'none':
        selectedRows = [];
        break;
      default:
        selectedRows = evt;
        break;
    }

    this.setState({
      selectedRows,
    });
  };

  handleFilterValueChange = (filter) => {
    const { customers } = this.props;
    const { page, limit, sortBy } = this.state;

    this.setState(getData(customers, sortBy, filter, page, limit));
  };

  handleSortOrderChange = (key, order) => {
    console.log('key', key);
    let sortBy = getSorter();
    switch (key) {
      case 'name':
        sortBy = getSorter((a, b) => sortStrings(a.name, b.name), order);
        break;
      case 'customerManager':
        sortBy = getSorter((a, b) => sortStrings(a.customerManager ? a.customerManager.name : '', b.customerManager ? b.customerManager.name : ''), order);
        break;
      case 'primaryContact.name':
        sortBy = getSorter((a, b) => sortStrings(a.primaryContact ? a.primaryContact.name : '', b.primaryContact ? b.primaryContact.name : ''), order);
        break;
      case 'primaryContact.email':
        sortBy = getSorter((a, b) => sortStrings(a.primaryContact ? a.primaryContact.email : '', b.primaryContact ? b.primaryContact.email : ''), order);
        break;
      // case 'start':
      //   this.setState({
      //     sortBy: getSorter((a, b) => sortDates(a.start, b.start), order),
      //     order,
      //   });
      //   break;
      // case 'end':
      //   this.setState({
      //     sortBy: getSorter((a, b) => sortDates(a.end, b.end), order),
      //     order,
      //   });
      //   break;
      // case 'tasks':
      //   this.setState({
      //     sortBy: getSorter((a, b) => {
      //       const aCount = (a && a.tasks && a.tasks.count) ? a.tasks.count : 0;
      //       const bCount = (b && b.tasks && b.tasks.count) ? b.tasks.count : 0;
      //
      //       return aCount - bCount;
      //     }, order),
      //     order,
      //   });
      //   break;
      default:
        break;
    }

    // this.setState({
    //   data: this.state.data.sort(sortBy),
    //   sortBy,
    // });
    const { filter, page, limit } = this.state;
    this.setState(getData(this.props.customers, sortBy, filter, page, limit));
  };

  handlePreviousPageClick = () => {
    this.setState({
      page: Math.max(1, this.state.page - 1),
    });
  };

  handleNextPageClick = () => {
    const { data, page, limit } = this.state;

    this.setState({
      page: Math.min(Math.ceil(data.length / limit), page + 1),
    });
  };

  handleRowSizeChange = (a, limit) => {
    this.setState({
      limit,
      page: 1,
    });
  };

  renderNoData() {
    return (<TableRow key="nodata">
      <TableRowColumn colSpan={4} style={styles.noDataRow}>
        <FontIcon className="material-icons" style={styles.noData}>business</FontIcon>
        <div>No customers are available</div>
      </TableRowColumn>
    </TableRow>);
  }

  render() {
    const { loading } = this.props;
    const { editable, page, limit, data } = this.state;

    return (
      <Dashboard title="Customers" style={styles.wrapper}>

        <div style={styles.wrapper}>
          { !loading ? <DataTables
            height={'auto'}
            selectable
            multiSelectable
            showRowHover
            columns={getTableColumns(editable, this.handleEdit, this.handleRemove)}
            data={data.slice((page - 1) * limit, page * limit)}
            showCheckboxes
            enableSelectAll
            selectedRows={this.state.selectedRows}
            onFilterValueChange={this.handleFilterValueChange}
            onSortOrderChange={this.handleSortOrderChange}
            onPreviousPageClick={this.handlePreviousPageClick}
            onNextPageClick={this.handleNextPageClick}
            onRowSizeChange={this.handleRowSizeChange}
            onRowSelection={this.handleRowSelection}
            page={page}
            rowSize={limit}
            rowSizeList={[10, 25, 50, 100]}
            count={data.length}
            filterHintText="Filter"
            headerToolbarMode="filter"
            showHeaderToolbar
          /> : <Loading/> }
        </div>

        { editable ? <FloatingActionButton
          style={styles.addItem}
          secondary
          onClick={() => {
            this.props.setCustomer({});
            this.props.showDialog('customer');
          }}
        >
          <ContentAdd />
        </FloatingActionButton> : null }

        { isDialogOpen(this.props.dialogs, 'customer') ? <Customer /> : null }
      </Dashboard>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchCustomers,
    setCustomer,
    removeCustomer: removeCustomerRoutine.trigger,
    showDialog,
    hideDialog,
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    customers: state.get('customers').get('customers').toJS(),
    loading: state.get('customers').get('loading'),
    dialogs: state.get('dialogs').get('dialogs').toJS(),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Customers);



// WEBPACK FOOTER //
// ./src/components/Customers/index.js